import * as ApiRoutes from 'automation-ui-canvas/data/api/ApiRoutes';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME = 'flowByRevisionTimestamp';
export const GET_FLOW_BY_REVISION_TIMESTAMP = registerQuery({
  fieldName: FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME,
  args: ['flowId', 'revisionTimestamp'],
  fetcher: ({
    flowId,
    revisionTimestamp
  }) => {
    return http.get(`${ApiRoutes.HYBRID_FLOW_REVISIONS}/${flowId}/timestamp/${revisionTimestamp}`);
  }
});
export const FLOW_BY_VERSION_ID_FIELD_NAME = 'flowByVersionId';
export const GET_FLOW_BY_VERSION_ID = registerQuery({
  fieldName: FLOW_BY_VERSION_ID_FIELD_NAME,
  args: ['flowId', 'versionId'],
  fetcher: ({
    flowId,
    versionId
  }) => {
    return http.get(`${ApiRoutes.HYBRID_FLOW_REVISIONS}/${flowId}/${versionId}`);
  }
});